import PageHeader from "@/components/page-header";
import { HelpCatalog } from "@/components/registrant/help/help-portal";
import { INSPECTION_HELP_PORTAL } from "@/lib/inspection-help";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/inspection/help/")({
  component: InspectionHelpIndex,
});

function InspectionHelpIndex() {
  const [search, setSearch] = useState("");
  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle="Search or browse topics for the inspection portal"
        className="mb-6"
      />
      <HelpCatalog
        search={search}
        onSearchChange={setSearch}
        catalog={INSPECTION_HELP_PORTAL}
      />
    </div>
  );
}
